import {
  UPDATE_PROFILE,
  GET_PROFILE,
  FETCH_START,
  FETCH_ERROR,
  FETCH_SUCCESS,
  ADD_PROFILE,
  SHOW_MESSAGE,
} from "../../shared/constants/ActionTypes";

import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const getProfile = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get("/profile", {
        params: {},
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_PROFILE, payload: data.data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const updateProfile = (body) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .put("/admin/update", body)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Profile updated successfully.",
          });
          dispatch({ type: UPDATE_PROFILE, payload: data.data });
          const oldUserInfo = JSON.parse(localStorage.getItem("user_data"));
          const newUserInfo = { ...oldUserInfo, ...data.data.data };
          localStorage.setItem("user_data", JSON.stringify(newUserInfo));
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const changePassword = (body) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/admin/change-password", body)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SHOW_MESSAGE, payload: data.data.msg });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: data.data.msg
              ? data.data.msg
              : "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const addProfile = (profile) => {
  return (dispatch) => {
    dispatch({ type: ADD_PROFILE, payload: profile });
  };
};
